<div
    [class]="setStyleFlag() ? 'bg-primary' : 'bg-white'"
    class="px-4 py-3 flex w-full justify-between gap-2.5 rounded-xl relative"
>
    @if (!completenessError()) {
        @if (open()) {
            <app-chat-tooltip
                animate.leave="fade-out"
                (close)="open.set(false)"
                class="absolute bottom-[calc(100%+12px)]"
            >
                원하시는 날짜를 선택하여 상담 또는 치료 일정을 등록해주세요
            </app-chat-tooltip>
        }
    }
    @if (!open() && completenessError() === "4") {
        <app-chat-tooltip
            disableClose
            animate.leave="fade-out"
            (close)="open.set(false)"
            class="absolute bottom-[calc(100%+12px)]"
        >
            일정을 등록해주세요
        </app-chat-tooltip>
    }
    <div class="flex gap-2.5 items-center">
        <p
            [class]="setStyleFlag() ? 'text-white' : 'text-gray-800'"
            [class.!text-gray-400]="completeness()?.createSchedule"
            class="lg:text-base text-sm"
        >
            일정 등록
        </p>

        @if (completeness()?.createSchedule) {
            <div class="badge bg-gray-400">완료</div>
        } @else {
            <div
                [class]="
                    setStyleFlag()
                        ? 'bg-white !text-gray-800'
                        : 'text-white bg-primary'
                "
                class="badge"
            >
                등록 필요
            </div>
        }
    </div>

    <div routerLink="/schedule" class="flex gap-2 items-center cursor-pointer">
        @if (completeness()?.createSchedule) {
            <p class="text-gray-400 text-sm lg:block hidden">등록완료</p>
        } @else {
            <p
                [class]="setStyleFlag() ? 'text-white' : 'text-gray-400 '"
                class="text-sm lg:block hidden"
            >
                등록하기
            </p>
        }
        <app-icon
            name="material-symbols:arrow-forward-ios"
            class="!size-3.5 text-gray-300"
        />
    </div>
</div>
